import Button from '@/shared/components/Button/Button'
import { useState } from 'react'
import DynamicForm from '@/shared/components/DynamicForm/DynamicForm'
import { useTranslation } from 'react-i18next'
import { getFormConfig } from '@/features/auth/Forms/ResetPassword/ResetPasswordFormConfig'
import styles from '@/features/auth/Forms/ResetPassword/ResetPassword.module.scss'

function ResetPassword() {
  const [isDirty, setIsDirty] = useState(true)
  const { t } = useTranslation()
  const formConfig = getFormConfig(t)

  return (
    <div className={`${styles.resetPasswordContainer}`}>
      <h1 className={`title-bold-medium ${styles.resetPasswordHeader}`}>
        {t('AUTHORIZATION.RESET_PASSWORD.TITLE.FIRST_PART')}{' '}
        <mark className="mark-orange">
          {t('AUTHORIZATION.RESET_PASSWORD.TITLE.SECOND_PART')}
        </mark>
      </h1>
      <p className={`body-bold-medium ${styles.resetPasswordSubHeader}`}>
        {t('AUTHORIZATION.RESET_PASSWORD.SUB_TITLE')}
      </p>
      <DynamicForm setIsDirty={setIsDirty} validationMode="onSubmit" {...formConfig} />
      <div className={`${styles.resetPasswordFormButtonContainer}`}>
        <Button
          onClick={() => {}}
          label={t('AUTHORIZATION.RESET_PASSWORD.RESET_PASSWORD')}
          variant="contained"
          color="primary"
          type="submit"
          disabled={isDirty}
          maxWidth
        />
      </div>
    </div>
  )
}

export default ResetPassword
